import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import AssessmentBuilderMain from './AssessmentBuilderMain';
import StudyDesignReview from '../studybuilder/StudyDesignReview';
import ReviewActionBar from './ReviewActionBar';

/**
 * Wraps a builder in "review mode": renders the real builder so the approver can
 * see the content, with a fixed ReviewActionBar (Approve / Deny / History) pinned
 * to the bottom. The reviewable entity is passed through router state from the
 * list/queue so the bar can label it and link its history; ident falls back to
 * the URL param (assessment) or localStorage (study draft) on a hard refresh.
 *
 * Props:
 *   entityType - 'assessment' | 'study'
 */
const ReviewFrame = ({ entityType }) => {
  const params = useParams();
  const location = useLocation();
  const entity = location.state?.reviewEntity || null;

  const ident =
    entityType === 'assessment'
      ? params.assessmentId || entity?.uuid
      : entity?.id || localStorage.getItem('currentStudyDraftId');

  const Builder = entityType === 'study' ? StudyDesignReview : AssessmentBuilderMain;

  return (
    <div className="relative">
      <Builder />
      <ReviewActionBar entityType={entityType} ident={ident} entity={entity} />
    </div>
  );
};

export default ReviewFrame;
